
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../_helpers/apiConfig';



export const getSessionList = createAsyncThunk("adminApi/bookList", async (filters) => {
    const response = await apiRequest('POST', '/v1/adminApi/bookList', filters);
    return response;
});



const sessionSlice = createSlice({
    name: 'sessions',
    initialState: {
        sessions: [],
        totalSession: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSessionList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSessionList.fulfilled, (state, action) => {
                state.loading = false;
                state.sessions = action?.payload?.data?.list;
                state.totalSession = action?.payload?.data?.total;

            })
            .addCase(getSessionList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })





    },
});

export default sessionSlice.reducer;